import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { lifecycle, mapProps, compose } from 'recompose'

import {
  info
} from './actions'

const mapDispatchToProps = (dispatch) => {
  return {
    notify: (message) => dispatch(info(message))
  }
}

const withConnect = connect(() => ({}), mapDispatchToProps)

export default compose(
  withConnect,
  mapProps(({ notify, onMouseOver, message, ...rest}) => ({
    ...rest,
    mouseOverHandler(event) {
      if(onMouseOver)
        onMouseOver(event)
      notify(message)
    }
  })),
  lifecycle({
    componentDidMount() {
      ReactDOM.findDOMNode(this).addEventListener('mouseover', this.props.mouseOverHandler);
    },
    componentWillUnmount() {
      ReactDOM.findDOMNode(this).removeEventListener('mouseover', this.props.mouseOverHandler);
    }
  }),
  mapProps(({mouseOverHandler, ...rest}) => ({...rest}))
)
